export function setMapSQL(sql, data, ...params) {
    return function (dispatch) {
        dispatch({
            type: "SET_MAP_SQL",
            payload: {sql, data, params},
        });
    };
}
